var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("The list of plan items")]),_c('base-table',{staticClass:"shadow-none border-secondary",attrs:{"items":_vm.currentPlan.items,"table-top":"","paginate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }